import ContactForm from "../components/ContactForm";
import SiteLayout from "../components/SiteLayout";
import { companyProfile } from "../data/siteContent";

const ContactPage = () => {
  return (
    <SiteLayout>
      <div className="page-shell" data-testid="contact-page">
        <section className="contact-grid contact-grid--contact-simple">
          <div>
            <div className="eyebrow stagger-1" data-testid="contact-page-eyebrow">
              Contact
            </div>
            <h1 className="page-title stagger-2" data-testid="contact-page-title">
              Contact
            </h1>
            <p className="contact-copy stagger-3" data-testid="contact-page-copy">
              For inquiries, contact Hailo Digital directly or send a message through the form.
            </p>
            <p className="contact-meta stagger-4" data-testid="contact-email-inline">
              <a className="contact-link" data-testid="contact-email-inline-link" href={`mailto:${companyProfile.contactEmail}`}>
                {companyProfile.contactEmail}
              </a>
            </p>
          </div>
        </section>

        <section>
          <article className="contact-card stagger-4" data-testid="contact-form-card">
            <h2 className="contact-heading" data-testid="contact-form-heading">
              Send a message.
            </h2>
            <ContactForm />
          </article>
        </section>
      </div>
    </SiteLayout>
  );
};

export default ContactPage;